import React from "react";

const EVENT_LABELS = {
    requested: "Order Requested",
    invoice_sent: "Invoice Sent",
    paid: "Payment Confirmed",
    coc_pdf_generated: "Chain of Custody Form Generated",
    coc_pdf_downloaded: "Chain of Custody Form Downloaded",
    shipped: "Order Shipped",
    received: "Receipt Confirmed",
    seller_pickup_confirmed: "Seller Confirmed Pickup Handoff",
    buyer_pickup_confirmed: "Buyer Confirmed Pickup",
    seller_delivery_confirmed: "Seller Confirmed Delivery Handoff",
    buyer_delivery_confirmed: "Buyer Confirmed Delivery",
    completed: "Completed",
    denied: "Order Denied",
    cancelled: "Order Cancelled",
};

const EVENT_ICONS = {
    requested: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
            <path d="M14 2v6h6" />
        </svg>
    ),
    invoice_sent: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z" />
            <path d="M8 10h8" />
            <path d="M8 14h4" />
        </svg>
    ),
    paid: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="1" x2="12" y2="23" />
            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
    ),
    coc_pdf_generated: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
            <path d="M14 2v6h6" />
            <path d="M9 15l2 2 4-4" />
        </svg>
    ),
    coc_pdf_downloaded: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <path d="M7 10l5 5 5-5" />
            <path d="M12 15V3" />
        </svg>
    ),
    shipped: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 18H3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v11" />
            <path d="M14 9h4l4 4v4c0 .6-.4 1-1 1h-2" />
            <circle cx="7" cy="18" r="2" />
            <path d="M15 18H9" />
            <circle cx="17" cy="18" r="2" />
        </svg>
    ),
    received: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
            <path d="m9 12 2 2 4-4" />
        </svg>
    ),
    seller_pickup_confirmed: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
        </svg>
    ),
    buyer_pickup_confirmed: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
        </svg>
    ),
    seller_delivery_confirmed: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
        </svg>
    ),
    buyer_delivery_confirmed: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
        </svg>
    ),
    completed: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    denied: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
    ),
    cancelled: (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
    ),
};

/**
 * Format a timestamp into a relative time string.
 * @param {string} ts — ISO or MySQL timestamp
 * @returns {string}
 */
function formatRelativeTime(ts) {
    if (!ts) return "";
    const date = new Date(ts);
    const now = new Date();
    const diffMs = now - date;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);

    if (diffSec < 60) return "just now";
    if (diffMin < 60) return `${diffMin} minute${diffMin !== 1 ? "s" : ""} ago`;
    if (diffHour < 24) return `${diffHour} hour${diffHour !== 1 ? "s" : ""} ago`;
    if (diffDay < 30) return `${diffDay} day${diffDay !== 1 ? "s" : ""} ago`;

    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
}

/**
 * Format a timestamp into a full date/time string for tooltip.
 */
function formatFullDate(ts) {
    if (!ts) return "";
    return new Date(ts).toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
    });
}

const OrderTimeline = ({ timeline }) => {
    if (!timeline || timeline.length === 0) return null;

    return (
        <div className="order-timeline">
            <h4 className="order-timeline__title">Timeline</h4>
            <div className="order-timeline__list">
                {timeline.map((event, idx) => {
                    const isLast = idx === timeline.length - 1;
                    const isNegative = event.event === "denied" || event.event === "cancelled";

                    return (
                        <div
                            key={`${event.event}-${idx}`}
                            className={`order-timeline__item ${isLast ? "order-timeline__item--last" : ""} ${isNegative ? "order-timeline__item--negative" : ""}`}
                        >
                            <div className="order-timeline__marker">
                                <div className={`order-timeline__dot ${isLast ? "order-timeline__dot--current" : ""} ${isNegative ? "order-timeline__dot--negative" : ""}`}>
                                    {EVENT_ICONS[event.event] || null}
                                </div>
                                {!isLast && <div className="order-timeline__line" />}
                            </div>
                            <div className="order-timeline__content">
                                <span className="order-timeline__label">
                                    {EVENT_LABELS[event.event] || event.event}
                                </span>
                                <span
                                    className="order-timeline__time"
                                    title={formatFullDate(event.timestamp)}
                                >
                                    {formatRelativeTime(event.timestamp)}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default OrderTimeline;
